import ReactGA from "react-ga4";

import { JwtService } from "./Jwt.service";

type User = {
  email?: string;
  firstName?: string;
  lastName?: string;
  id?: string;
  authorities?: ("ROLE_USER" | "ROLE_ADMIN")[];
};

class GoogleAnalytics {
  private initialized = false;

  isEmployee(user: User): boolean {
    if (!user.email) {
      return false;
    }

    return /@cleverfarm\./i.test(user.email);
  }

  initialize(user: User): void {
    if (this.initialized) {
      return;
    }

    if (this.isEmployee(user)) {
      return;
    }

    if (JwtService.isImpersonatedToken()) {
      return;
    }

    const gaId = process.env.GOOGLE_ANALYTICS_ID;

    if (!gaId) {
      return;
    }

    ReactGA.initialize(gaId);
    this.initialized = true;
  }

  isInitialized(): boolean {
    return this.initialized;
  }
}

const GoogleAnalyticsService = new GoogleAnalytics();
export { GoogleAnalyticsService };
